import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IResetPasswordStep2ReqBody, IResetPasswordStep2Entity } from '../../../entity';

export interface IResetPaswordStep2UseCase {
    execute(lang: string, reqBody: IResetPasswordStep2ReqBody): Promise<IResetPasswordStep2Entity>;
}

export class ResetPaswordStep2UseCase implements IResetPaswordStep2UseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(lang: string, reqBody: IResetPasswordStep2ReqBody): Promise<IResetPasswordStep2Entity> {
        return await this.userRepo.resetPaswordStep2(lang, reqBody);
    }
}
